<template>
  <!-- Body -->
  <div class="d-flex flex-column align-center">
    <div id="building">
      <div class="sprite-container">
        <div class="sprite" v-if="isOngoingEvent"></div>
      </div>
      <v-img
        @click="enter"
        @mouseover="isOpen = true"
        @mouseleave="isOpen = false"
        id="entrance"
        :src="isOpen ? srcOpen : srcClose"
        lazy
      ></v-img>
      <div class="crowd" v-if="isOngoingEvent">
        <div class="crowd-row">
          <div
            id="avatar"
            v-for="i in 4"
            :key="'r1' + i"
            :class="i == 3 || i == 4 ? 'flip-horizontal' : ''"
          >
            <AbstractNPC
              :avatar="npcList[i - 1].avatar"
              :height="100"
              :width="100"
              class="mx-auto animated-avatar"
            />
          </div>
        </div>
        <!-- <div class="crowd-row row-2">
          <div id="avatar" v-for="i in 2" :key="'r2' + i" :class="i == 2 ? 'flip-horizontal' : ''">
            <AbstractNPC
              :avatar="npcList[i + 3].avatar"
              :height="100"
              :width="100"
              class="mx-auto animated-avatar"
            />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    AbstractNPC: () => ({
      component: import(
        /* webpackChunkName: "component-abstract-npc" */ "@/components/npc/AbstractNPC"
      ),
    }),
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: {
    isOngoingEvent: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isOpen: false,
    srcClose: require("@/assets/world/buildings/WorldBuildingEventEntrance.png"),
    srcOpen: require("@/assets/world/buildings/WorldBuildingEventEntranceOpen.png"),
    npcList: [
      {
        name: "Katy",
        avatar:
          '{"charKey":"mochi_v4","body":"cat","mouth":"cat","pColor":"FCE83F","hat":"","left":"","right":"","back":""}',
      },
      {
        name: "Beary",
        avatar:
          '{"charKey":"mochi_v4","body":"bear","mouth":"bear","pColor":"C67334","hat":"","left":"","right":"","back":""}',
      },
      {
        name: "Ruby",
        avatar:
          '{"charKey":"mochi_v4","body":"rabbit","mouth":"rabbit","pColor":"c3ffbf","hat":"","left":"","right":"","back":""}',
      },
      {
        name: "Kumar",
        avatar:
          '{"charKey":"mochi_v4","body":"rabbit","mouth":"rabbit","pColor":"F1F1F1","hat":"","left":"","right":"","back":""}',
      },
      {
        name: "Katy",
        avatar:
          '{"charKey":"mochi_v4","body":"cat","mouth":"cat","pColor":"ffbfcc","hat":"","left":"","right":"","back":""}',
      },
      {
        name: "Beary",
        avatar:
          '{"charKey":"mochi_v4","body":"bear","mouth":"bear","pColor":"bfedff","hat":"","left":"","right":"","back":""}',
      },
    ],
  }),
  created() {
    this.npcList = this.shuffleArray(this.npcList);
  },
  mounted() {
    //
  },
  methods: {
    enter() {
      this.$intro().exit();
      this.isOpen = true;
      this.$router.push({ name: "PageExploreSeries" });
    },

    shuffleArray(array) {
      const shuffled = [...array];

      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }

      return shuffled;
    },
  },
};
</script>

<style scoped>
#building {
  position: absolute;
  background-image: url("../../../assets/world/buildings/WorldBuildingEvent_960x512.png");
  width: 100vw;
  height: 100vh;
  bottom: 160px;
  background-size: auto;
  background-position: center bottom;
}

#entrance {
  cursor: pointer;
  position: absolute;
  width: 156px;
  height: 183px;
  bottom: 70px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  filter: drop-shadow(3px 0 0 rgba(255, 255, 255, 0.3))
    drop-shadow(-3px 0 0 rgba(255, 255, 255, 0.3))
    drop-shadow(0 3px 0 rgba(255, 255, 255, 0.3))
    drop-shadow(0 -3px 0 rgba(255, 255, 255, 0.3));
}

#entrance:hover {
  /* transform: scale(1.05); */
  filter: drop-shadow(0 0 4px rgba(255, 255, 0, 0.8))
    drop-shadow(0 0 8px rgba(255, 255, 0, 0.6))
    drop-shadow(0 0 12px rgba(255, 255, 0, 0.4));
}

.crowd {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  bottom: 50px;
  pointer-events: none;
  width: 480px;
  overflow: hidden;
  color: #ffbfcc;
  left: 50%; /* Center point of the parent */
  transform: translateX(-50%); /* Shift left by half of its own width */
}

.crowd-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 480px;
  overflow: hidden;
}

.row-2 {
  margin-top: -50px;
}

.flip-horizontal {
  transform: scaleX(-1);
}

.sprite-container {
  max-width: 300px;
  width: 100%;
  height: 300px;
  margin: auto;
  overflow: hidden;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 350px;
  z-index: 1;
  pointer-events: none;
  transform: rotate(-90deg)
}

.sprite {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  animation: swapImage 1s steps(1) infinite;
}

/* Keyframes to swap between two images */
@keyframes swapImage {
  0% {
    background-image: url("../../../assets/world/shout_1.png");
  }
  50% {
    background-image: url("../../../assets/world/shout_3.png");
  }
  100% {
    background-image: url("../../../assets/world/shout_1.png");
  }
}
</style>